/**
 * @generated SignedSource<<f3d7efe2efb8521ac39409b96cee46e7>>
 * @relayHash 62e15c72deef7eaf4c9035e5e1976db0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 58bfe0135afad3b1d316f22b2877ad9574655e849a508aebd203bfbc9e5828dc

import type { ConcreteRequest } from 'relay-runtime';
export type workspaceThemeManagementGetWorkspaceThemePreferenceQuery$variables = {
  accountId: string;
  workspaceAri: string;
};
export type workspaceThemeManagementGetWorkspaceThemePreferenceQuery$data = {
  readonly settings_userPreferencesResolved: {
    readonly theme: string | null;
  } | null;
};
export type workspaceThemeManagementGetWorkspaceThemePreferenceQuery = {
  response: workspaceThemeManagementGetWorkspaceThemePreferenceQuery$data;
  variables: workspaceThemeManagementGetWorkspaceThemePreferenceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
      }
    ],
    "concreteType": "SettingsUserPreferences",
    "kind": "LinkedField",
    "name": "settings_userPreferencesResolved",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "theme"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "58bfe0135afad3b1d316f22b2877ad9574655e849a508aebd203bfbc9e5828dc",
    "metadata": {},
    "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3f7fd599e886181a5359ad8f6fbe4487";

export default node;
